import { Recaptcha, RecaptchaProps } from "infra";

type GoogleRecaptchaProps = RecaptchaProps;

const GoogleRecaptcha = ({ ...rest }: GoogleRecaptchaProps) => {
  return <Recaptcha {...rest} />;
};

export { GoogleRecaptcha };
